var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReport4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 33,
    viewBox: "0 0 30 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5312 10.875H12.4688C11.8465 10.875 11.3438 11.3777 11.3438 12V31.125C11.3438 31.7473 11.8465 32.25 12.4688 32.25H17.5312C18.1535 32.25 18.6562 31.7473 18.6562 31.125V12C18.6562 11.3777 18.1535 10.875 17.5312 10.875ZM28.3594 0.75H23.2969C22.6746 0.75 22.1719 1.25273 22.1719 1.875V31.125C22.1719 31.7473 22.6746 32.25 23.2969 32.25H28.3594C28.9816 32.25 29.4844 31.7473 29.4844 31.125V1.875C29.4844 1.25273 28.9816 0.75 28.3594 0.75ZM6.70312 21H1.64062C1.01836 21 0.515625 21.5027 0.515625 22.125V31.125C0.515625 31.7473 1.01836 32.25 1.64062 32.25H6.70312C7.32539 32.25 7.82812 31.7473 7.82812 31.125V22.125C7.82812 21.5027 7.32539 21 6.70312 21Z",
    fill: "#1A5785"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport4);
export default __webpack_public_path__ + "static/media/report4.b1dbdeac013ea0047a5850cf08f00264.svg";
export { ForwardRef as ReactComponent };